import axios from "axios";
import API_VERSION from "../data/api-version";

const ShopifyGetCollectionsForTab = async (titles) => {
  const mapped = titles.map((title) => `(title:${title})`);
  const joined = mapped.join(" OR ");
  const fAmount = titles.length + 10; // made 10 because of the collision of the collection names 'Girl Scouts' & 'Bluey Friends'

  try {
    const response = await axios({
      url: `https://${process.env.REACT_APP_SHOP_URL}/api/${API_VERSION}/graphql.json`,
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": process.env.REACT_APP_SHOP_ACCESS_TOKEN,
      },
      data: {
        query: `{
          collections(first:${fAmount}, query:"${joined}") {
            edges {
              node {
                id
                title
                products(first:50) {
                  edges {
                    node {
                      image: featuredImage {
                        url(transform: {maxHeight: 500})
                      }
                      points: metafield(key:"patch_points", namespace:"my_fields") {
                        value
                      }
                      material: metafield(key:"patch_material", namespace:"my_fields") {
                        value
                      }
                    }
                  }
                }
                image: metafield(key:"customizer_collection_image", namespace:"custom") {
                  value
                  reference {
                    ... on MediaImage {
                      image {
                        url(transform: {maxHeight: 500})
                      }
                    }
                  }
                }
              }
            }
          }
        }`,
      },
    });
    if (response.data.data.collections) {
      const { collections } = response.data.data;

      return collections.edges
        .filter((e) => e.node.products.edges.some((p) => p.node.points !== null))
        .map((e) => ({
          id: e.node.id,
          title: e.node.title,
          patches: e.node.products.edges
            .filter((f) => f.node.points !== null)
            .map((f) => ({
              image: f.node.image ? f.node.image.url : "",
              points: parseInt(f.node.points.value),
              material: f.node.material ? f.node.material.value : "",
            })),
          src: e.node.image
            ? e.node.image.reference.image.url
            : e.node.products.edges[0]
            ? e.node.products.edges[0].node.image.url
            : "",
        }));
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default ShopifyGetCollectionsForTab;
